<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="mt-2 col-md-12"></div>

    <div class="noAlMargen">


      <b-form v-on:submit.prevent="enviarDatos">
        <b-row>
          <b-col class="text-left">
            <label>Tipo de color: *</label>
            <b-form-select
              v-model="empatia.colorSeleccionado"
              :options="colores"
              value-field="idEtiqueta"
              text-field="descripcion"
              :state="empatia.colorSeleccionado != null"
              required
            >
            </b-form-select>
            <b-form-invalid-feedback :state="empatia.colorSeleccionado != null"
              >Selecciona una opción</b-form-invalid-feedback
            >
          </b-col>
          <b-col class="text-left">
            <label>Tipo de empatia: *</label>
            <b-form-select
              v-model="empatia.tipoSeleccionado"
              :options="tipoEmpatia"
              value-field="idTipoEmpatia"
              text-field="descripcion"
              :state="empatia.tipoSeleccionado != null"
              required
            >
            </b-form-select>
            <b-form-invalid-feedback :state="empatia.tipoSeleccionado != null"
              >Selecciona una opción</b-form-invalid-feedback
            >
          </b-col>
          <b-col class="text-left">
            <label>Tipo de personaliada: *</label>
            <b-form-select
              v-model="empatia.personaSeleccionado"
              :options="personalidad"
              value-field="idPersonalidad"
              text-field="descripcion"
              :state="empatia.personaSeleccionado != null"
              required
            >
            </b-form-select>
            <b-form-invalid-feedback
              :state="empatia.personaSeleccionado != null"
              >Selecciona una opción</b-form-invalid-feedback
            >
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col class="text-left">
            <label> Descripción: </label>
            <b-form-textarea
              v-model="empatia.descripcion"
              placeholder="Descripción general:"
            >
            </b-form-textarea>
          </b-col>
        </b-row>

        <b-button
          class="mt-4"
          type="submit"
          variant="outline-primary"
          v-if="!enviando && $localStorageService.can('CA_08_guardar_empatia')"
        >
          Guardar</b-button
        >
        <b-button class="mt-4" variant="primary" v-show="enviando" disabled>
          <b-spinner small></b-spinner>
          Cargando...
        </b-button>
      </b-form>
    </div>
  </div>
</template>
<script>
import VueNotifications from "vue-notifications";

export default {
  name: "Empatia",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    colores: [],
    tipoEmpatia: [],
    personalidad: [],
    existeEmpatia: false,
    idPaciente: null,
    empatia: {
      colorSeleccionado: null,
      tipoSeleccionado: null,
      personaSeleccionado: null,
      descripcion: "",
      idEmpatia: null,
    },
    enviando: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idPaciente = this.$route.params.id;
    //traer lista de tipoEmpatia, colores y personalidad
    this.traerColores();
    this.traerTipoEmpatia();
    this.traerPersonalidad();

    //si tiene datos traemos esos datos
    this.traerEmpatia();
  },
  methods: {
    traerColores() {
      let urlColores = this.$api + "catalogos/listaEtiquetas";
      this.$http
        .get(urlColores)
        .then((response) => {
          if (response.data.data) {
            response.data.data.unshift({
              idEtiqueta: null,
              descripcion: "Color:",
            });
            this.colores = response.data.data;
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
        });
    },
    traerTipoEmpatia() {
      let urlTipoEmpatia = this.$api + "catalogos/listaTipoEmpatia";
      this.$http
        .get(urlTipoEmpatia)
        .then((response) => {
          if (response.data.data) {
            response.data.data.unshift({
              idTipoEmpatia: null,
              descripcion: "Tipo Empatia:",
            });
            this.tipoEmpatia = response.data.data;
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
        });
    },
    traerPersonalidad() {
      let urlPersonalidad = this.$api + "catalogos/listaPersonalidad";

      this.$http
        .get(urlPersonalidad)
        .then((response) => {
          if (response.data.data) {
            response.data.data.unshift({
              idPersonalidad: null,
              descripcion: "Personalidad:",
            });
            this.personalidad = response.data.data;
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
        });
    },
    traerEmpatia() {
      let urlPaciente =
        this.$api + "paciente/obtenerEmpatia";

      this.$http.post(urlPaciente, this.idPaciente).then((response) => {
        if (response.data.data) {
          this.empatia.idEmpatia = response.data.data.idEmpatia;
          this.empatia.colorSeleccionado = response.data.data.idEtiqueta;
          this.empatia.tipoSeleccionado = response.data.data.idTipoEmpatia;
          this.empatia.personaSeleccionado = response.data.data.idPersonadad;
          this.empatia.descripcion = response.data.data.descripcion;
          this.existeEmpatia = true;
        }
      });
    },
    enviarDatos() {
      this.$swal({
        icon: "info",
        text: "¿Los datos son correctos?",
        confirmButtonColor: "#0e6ba9",
        cancelButtonColor: "#8e8e8e",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.enviando = true;

          if (this.existeEmpatia) {
            this.editarEmpatia();
          } else {
            this.guardarEmpatia();
          }
        }
      });
    },
    guardarEmpatia() {
      let urlNuevaEmpatia = this.$api + "paciente/empatia";
      this.$http
        .post(urlNuevaEmpatia, this.traerDatos())
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              icon: "success",
              text: "datos ingresados correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
            this.enviando = false;
          }
        })
        .catch((err) => {
          this.enviando = false;
          this.errorEnvio(err);
        });
    },
    editarEmpatia() {
      let urlEditarEmpatia = this.$api + "paciente/empatia";
      this.$http
        .put(urlEditarEmpatia, this.traerDatos())
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              icon: "success",
              text: "datos ingresados correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
            this.enviando = false;
          }
        })
        .catch((err) => {
          this.enviando = false;
          this.errorEnvio(err);
        });
    },
    traerDatos() {
      let datos = {
        idEtiqueta: this.empatia.colorSeleccionado,
        idTipoEmpatia: this.empatia.tipoSeleccionado,
        idPersonadad: this.empatia.personaSeleccionado,
        descripcion: this.empatia.descripcion,
        usuarioLogeado: this.$localStorageService.getIdUsuario(),
      };

      this.existeEmpatia
        ? (datos.idEmpatia = this.empatia.idEmpatia)
        : (datos.idPaciente = this.idPaciente);
      return datos;
    },
  },
  notifications: {
    errorMensaje: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    },
    errorEnvio: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>
<style scoped>
.color {
  width: 16px;
  height: 16px;
  display: inline-block;
  margin-right: 16px;
  border: 1px solid gray !important;
}
</style>
